import { request } from "../http";

export default {
  // 案例分享
  shareCase(params) {
    return request("post", "/sd_smi/api/v1/H5_Case/shareCase", params, "json");
  },

  // 产品分享
  shareProduct(params) {
    return request(
      "post",
      "/sd_smi/api/v1/Web_Product/shareProduct",
      params,
      "json"
    );
  },

  // 样板间分享
  shareTemplate(params) {
    return request(
      "post",
      "/sd_smi/api/v1/Web_Template/shareTemplate",
      params,
      "json"
    );
  },

  // 样板间方案分享
  shareTemplatePlan(params) {
    return request(
      "post",
      "/sd_smi/api/v1/Web_Template/shareTemplatePlan",
      params,
      "json"
    );
  }
};



// WEBPACK FOOTER //
// ./src/request/apis/share.js